<template>
  <b-container fluid>
    <b-row>
      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.sexSelected"
          :options="sexOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.hairSelected"
          :options="hairOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>

      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.ethnicSelected"
          :options="ethnicOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.hairStyleSelected"
          :options="hairStyleOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>

      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.ageMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Věk od:"
        />
        <b-form-input
          v-model="peopleFilter.ageMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Věk do:"
        />
      </b-col>

      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.heightMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Výška od:"
        />
        <b-form-input
          v-model="peopleFilter.heightMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Výška do:"
        />
      </b-col>

      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.shoesMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Boty od:"
        />
        <b-form-input
          v-model="peopleFilter.shoesMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Boty do:"
        />
      </b-col>

      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.dressSizeSelected"
          :options="dressSizeOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.cathegorySelected"
          :options="cathegoryOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>

      <b-col cols="1">
        <form autocomplete="off">
          <b-form-input
            v-model="peopleFilter.name"
            type="text"
            size="sm"
            class="mt-3"
            placeholder="Jméno:"
          />
        </form>
        <b-form-input
          v-model.number="peopleFilter.IDPeople"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Číslo:"
        />
      </b-col>

      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.nationalitySelected"
          :options="nationalityOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.languageSelected"
          :options="languageOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>

      <b-col cols="1">
        <b-row>
          <b-button class="mt-3 btn-block" @click="filterPeople" size="sm" variant="success">Hledat</b-button>
        </b-row>
        <b-row>
          <b-button
            class="mt-3 btn-block"
            @click="cancelFilter"
            size="sm"
            variant="warning"
          >Zrušit filtr</b-button>
        </b-row>
      </b-col>
      <b-col cols="3">
        <b-row class="mx-0">
          <b-form-select
            :onchange="allowSelection()"
            v-model="selectionSelected"
            :options="selectionOptions"
            size="sm"
            class="mt-3"
            placeholder="Výběry"
          />
        </b-row>
        <b-row class="mx-0">
          <b-form-checkbox
            v-model="moreFilters"
            class="mt-3"
            switch
          >Další&nbsp;filtry &nbsp;&nbsp;&nbsp;&nbsp;Počet výsledků: {{$store.getters.cards.length}}</b-form-checkbox>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="moreFilters">
      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.breastMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Hruď od:"
        />
        <b-form-input
          v-model="peopleFilter.breastMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Hruď do:"
        />
      </b-col>
      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.waistMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Pas od:"
        />
        <b-form-input
          v-model="peopleFilter.waistMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Pas do:"
        />
      </b-col>
      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.hipsMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Boky od:"
        />
        <b-form-input
          v-model="peopleFilter.hipsMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Boky do:"
        />
      </b-col>
      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.neckMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Krk od:"
        />
        <b-form-input
          v-model="peopleFilter.neckMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Krk do:"
        />
      </b-col>
      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.headMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Hlava od:"
        />
        <b-form-input
          v-model="peopleFilter.headMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Hlava do:"
        />
      </b-col>

      <b-col cols="1">
        <b-form-input
          v-model="peopleFilter.childSizeMin"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Dítě V.od:"
        />
        <b-form-input
          v-model="peopleFilter.childSizeMax"
          type="number"
          size="sm"
          class="mt-3"
          placeholder="Dítě V.do:"
        />
      </b-col>

      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.nailsSelected"
          :options="nailsOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.nailsLengthSelected"
          :options="nailsLengthOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>

      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.drivingLicenseSelected"
          :options="drivingLicenseOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.glassesSelected"
          :options="glassesOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>
      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.komparzSelected"
          :options="komparzOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.tatooSelected"
          :options="tatooOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>
      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.nakedSelected"
          :options="nakedOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.piercingSelected"
          :options="piercingOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>
      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.underwearSelected"
          :options="underwearOptions"
          size="sm"
          class="mt-3"
        />
        <b-form-select
          v-model="peopleFilter.gdprSelected"
          :options="gdprOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>
      <b-col cols="1">
        <b-form-select
          v-model="peopleFilter.cameraExperienceSelected"
          :options="cameraExperienceOptions"
          size="sm"
          class="mt-3"
        />
      </b-col>
    </b-row>

    <hr />

    <b-row>
      <Cards :selectionSelected="selectionSelected" />
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios'
import Cards from '@/components/cards.vue'

export default {
  components: {
    Cards
  },
  data () {
    return {
      cardBtnDetail: true,
      cardBtnAddToSelection: false,
      cardBtnRemoveFromSelection: false,
      cardBtnConfirmed: false,
      selectionNotesTab: false,
      cardImgWidth: 15,
      cardImgHeight: 25,
      moreFilters: null,
      peopleInSelection: [],
      items: [],
      selectionSelected: null,
      peopleFilter: {
        ethnicSelected: null,
        sexSelected: null,
        hairSelected: null,
        hairStyleSelected: null,
        cathegorySelected: null,
        dressSizeSelected: null,
        childSizeMin: null,
        childSizeMax: null,
        ageMin: null,
        ageMax: null,
        heightMin: null,
        heightMax: null,
        shoesMin: null,
        shoesMax: null,
        breastMin: null,
        breastMax: null,
        waistMin: null,
        waistMax: null,
        hipsMin: null,
        hipsMax: null,
        neckMin: null,
        neckMax: null,
        headMin: null,
        headMax: null,
        name: null,
        IDPeople: null,
        nailsSelected: null,
        nailsLengthSelected: null,
        glassesSelected: null,
        tatooSelected: null,
        piercingSelected: null,
        nationalitySelected: null,
        languageSelected: null,
        drivingLicenseSelected: null,
        komparzSelected: null,
        nakedSelected: null,
        underwearSelected: null,
        gdprSelected: null,
        cameraExperienceSelected: null
      },
      sexOptions: [],
      ethnicOptions: [],
      dressSizeOptions: [],
      cathegoryOptions: [],
      hairOptions: [],
      hairStyleOptions: [],
      selectionOptions: [],
      nationalityOptions: [],
      nailsOptions: [],
      nailsLengthOptions: [],
      glassesOptions: [],
      languageOptions: [],
      drivingLicenseOptions: [],
      tatooOptions: [
        {
          value: null,
          text: 'Tetování:'
        },
        {
          value: true,
          text: 'Ano'
        },
        {
          value: false,
          text: 'Ne'
        }],
      piercingOptions: [
        {
          value: null,
          text: 'Piercing:'
        },
        {
          value: true,
          text: 'Ano'
        },
        {
          value: false,
          text: 'Ne'
        }],
      komparzOptions: [
        {
          value: null,
          text: 'Komparz:'
        },
        {
          value: true,
          text: 'Ano'
        },
        {
          value: false,
          text: 'Ne'
        }],
      nakedOptions: [
        {
          value: null,
          text: 'Nahota:'
        },
        {
          value: true,
          text: 'Ano'
        },
        {
          value: false,
          text: 'Ne'
        }],
      underwearOptions: [
        {
          value: null,
          text: 'S.Prádlo:'
        },
        {
          value: true,
          text: 'Ano'
        },
        {
          value: false,
          text: 'Ne'
        }],
      gdprOptions: [
        {
          value: null,
          text: 'GDPR:'
        },
        {
          value: true,
          text: 'Ano'
        },
        {
          value: false,
          text: 'Ne'
        }],
      cameraExperienceOptions: [
        {
          value: null,
          text: 'Zkušenost:'
        },
        {
          value: true,
          text: 'Ano'
        },
        {
          value: false,
          text: 'Ne'
        }]
    }
  },
  computed: {

  },
  methods: {
    filterPeople () {
      axios
        .get('/api/v1/people', {
          params: {
            sex: this.peopleFilter.sexSelected,
            ethnic: this.peopleFilter.ethnicSelected,
            hair: this.peopleFilter.hairSelected,
            hairStyle: this.peopleFilter.hairStyleSelected,
            cathegory: this.peopleFilter.cathegorySelected,
            dresssize: this.peopleFilter.dressSizeSelected,
            childsizemin: this.peopleFilter.childSizeMin,
            childsizemax: this.peopleFilter.childSizeMax,
            agemin: this.peopleFilter.ageMin,
            agemax: this.peopleFilter.ageMax,
            heightmin: this.peopleFilter.heightMin,
            heightmax: this.peopleFilter.heightMax,
            shoesmin: this.peopleFilter.shoesMin,
            shoesmax: this.peopleFilter.shoesMax,
            breastmin: this.peopleFilter.breastMin,
            breastmax: this.peopleFilter.breastMax,
            waistmin: this.peopleFilter.waistMin,
            waistmax: this.peopleFilter.waistMax,
            hipsmin: this.peopleFilter.hipsMin,
            hipsmax: this.peopleFilter.hipsMax,
            neckmin: this.peopleFilter.neckMin,
            neckmax: this.peopleFilter.neckMax,
            headmin: this.peopleFilter.headMin,
            headmax: this.peopleFilter.headMax,
            komparz: this.peopleFilter.komparzSelected,
            naked: this.peopleFilter.nakedSelected,
            underwear: this.peopleFilter.underwearSelected,
            gdpr: this.peopleFilter.gdprSelected,
            cameraExperience: this.peopleFilter.cameraExperienceSelected,
            name: this.peopleFilter.name,
            IDPeople: this.peopleFilter.IDPeople,
            nationality: this.peopleFilter.nationalitySelected,
            nails: this.peopleFilter.nailsSelected,
            nailsLength: this.peopleFilter.nailsLengthSelected,
            glasses: this.peopleFilter.glassesSelected,
            tatoo: this.peopleFilter.tatooSelected,
            piercing: this.peopleFilter.piercingSelected,
            language: this.peopleFilter.languageSelected,
            drivinglicense: this.peopleFilter.drivingLicenseSelected
          }
        })
        .then(response => (this.$store.commit('cards', response.data)))
    },
    cancelFilter () {
      this.peopleFilter.sexSelected = null
      this.peopleFilter.ethnicSelected = null
      this.peopleFilter.hairSelected = null
      this.peopleFilter.hairStyleSelected = null
      this.peopleFilter.cathegorySelected = null
      this.peopleFilter.dressSizeSelected = null
      this.peopleFilter.childSizeMin = null
      this.peopleFilter.childSizeMax = null
      this.peopleFilter.ageMin = null
      this.peopleFilter.ageMax = null
      this.peopleFilter.heightMin = null
      this.peopleFilter.heightMax = null
      this.peopleFilter.shoesMin = null
      this.peopleFilter.shoesMax = null
      this.peopleFilter.breastMin = null
      this.peopleFilter.breastMax = null
      this.peopleFilter.waistMin = null
      this.peopleFilter.waistMax = null
      this.peopleFilter.hipsMin = null
      this.peopleFilter.hipsMax = null
      this.peopleFilter.neckMin = null
      this.peopleFilter.neckMax = null
      this.peopleFilter.headMin = null
      this.peopleFilter.headMax = null
      this.peopleFilter.name = null
      this.peopleFilter.IDPeople = null
      this.peopleFilter.nationalitySelected = null
      this.peopleFilter.nailsSelected = null
      this.peopleFilter.nailsLengthSelected = null
      this.peopleFilter.glassesSelected = null
      this.peopleFilter.tatooSelected = null
      this.peopleFilter.piercingSelected = null
      this.peopleFilter.languageSelected = null
      this.peopleFilter.drivingLicenseSelected = null
      this.peopleFilter.komparzSelected = null
      this.peopleFilter.nakedSelected = null
      this.peopleFilter.underwearSelected = null
      this.peopleFilter.gdprSelected = null
      this.peopleFilter.cameraExperienceSelected = null
      axios
        .get('/api/v1/people')
        .then(response => (this.$store.commit('cards', response.data)))
    },
    allowSelection () {
      if (this.selectionSelected != null) {
        this.cardBtnAddToSelection = true
        axios
          .get('/api/v1/people', {
            params: {
              selection: this.selectionSelected
            }
          })
          .then(response => {
            if (response.data != null) {
              this.peopleInSelection = []
              response.data.forEach((data) => {
                this.peopleInSelection.push(data.id)
              })
            } else {
              this.peopleInSelection = []
            }
          })
      } else {
        this.peopleInSelection = []
        this.cardBtnAddToSelection = false
      }
    }
  },
  mounted () {
    // Pokial neni nadefinovany filter tak nenatahuj zo storu (pri prvom nacitni)
    if (this.$store.getters.peopleFilter.name !== undefined) {
      this.peopleFilter = this.$store.getters.peopleFilter
    }
    // nacitaj ludi podla filtra
    this.filterPeople()

    axios
      .get('/api/v1/const/sex')
      .then(response => (this.sexOptions = [{
        value: null,
        text: 'Pohlaví:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/ethnic')
      .then(response => (this.ethnicOptions = [{
        value: null,
        text: 'Etnikum:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/hair')
      .then(response => (this.hairOptions = [{
        value: null,
        text: 'Barva vlasů:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/hair-style')
      .then(response => (this.hairStyleOptions = [{
        value: null,
        text: 'Styl vlasů:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/cathegory')
      .then(response => (this.cathegoryOptions = [{
        value: null,
        text: 'Kategorie:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/dresssize')
      .then(response => (this.dressSizeOptions = [{
        value: null,
        text: 'Oblečení:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/selection')
      .then(response => (this.selectionOptions = [{
        value: null,
        text: 'Přidat do výběru:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/nationality')
      .then(response => (this.nationalityOptions = [{
        value: null,
        text: 'Národnost:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/nails')
      .then(response => (this.nailsOptions = [{
        value: null,
        text: 'N.Stav:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/nailsLength')
      .then(response => (this.nailsLengthOptions = [{
        value: null,
        text: 'N.délka:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/glasses')
      .then(response => (this.glassesOptions = [{
        value: null,
        text: 'Brýle:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/language')
      .then(response => (this.languageOptions = [{
        value: null,
        text: 'Jazyk:'
      }, ...response.data]))
    axios
      .get('/api/v1/const/drivinglicense')
      .then(response => (this.drivingLicenseOptions = [{
        value: null,
        text: 'Řidičák:'
      }, ...response.data]))
  },
  beforeDestroy () {
    // uloz aktualny filter do storu
    this.$store.commit('peopleFilter', this.peopleFilter) // Uloz aktualne nastavenie filtra do storu
  }
}
</script>

<style>
</style>
